module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Bold-fa4831903e74452d9c0d0e3a67689e34.svg";